import { bl_fi_budget_fiscal_year_RowClass } from '../../../dbschema/bl_fi_budget_fiscal_year.model';
import { BaseContainerModel } from '../../base-container.model';


export class BudgetFiscalYearContainerModel extends BaseContainerModel {
    bl_fi_budget_fiscal_year: bl_fi_budget_fiscal_year_RowClass = new bl_fi_budget_fiscal_year_RowClass();
}
